import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox, FieldLayoutGroup } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import clsx from 'clsx'

class ViewBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string
  })

  render () {
    const { type, groupButton, groupLabel, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ testId, showError, value, onChange, name, placeHolder, loading }) => <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
          <input data-tid={testId} type='text' className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')} readOnly name={`view${name}`} id={`view${name}`} value={value} />
        </FieldLayoutGroup>}
      </FieldLayoutBox>
    )
  }
};

export const ViewBox = ({ parse, format, fieldType, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={ViewBoxClass} /> } // eslint-disable-line
export default ViewBox
